import { render, staticRenderFns } from "./TypeProp.vue?vue&type=template&id=9f353902&scoped=true"
import script from "./TypeProp.vue?vue&type=script&lang=ts"
export * from "./TypeProp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f353902",
  null
  
)

export default component.exports